module.exports = __webpack_public_path__ + "static/catherine-c4a280abdfb157704dc1adb30a72b40d.png";